export default {
  TipoPerfilOperador: {
    Nenhum: 0,
    Administrador: 1,
    Operador: 1 << 1
  },
  ContextoAnalise: {
    Correntista: 1,
    OperadorBackoffice: 2,
    OperadorRetaguarda: 3,
    OperadorFrontend: 4,
    Conta: 5,
    Split: 6,
    LimiteOperacao: 7
  },
  IndicadorFraude: {
    Liquidacoes: 0,
    FraudesAplicadas: 1,
    ContasMula: 2,
    ContasGolpistas: 3,
    OutrasFraudes: 4,
    FraudesDesconhecidas: 5,
    RelatosRejeitados: 8
  },
  TipoPermissaoAnaliseCadastro: {
    Nenhum: 0,
    Criacao: 1,
    Edicao: 2,
    Vinculo: 4
  },
  AnaliseCadastralCRUDResposta: {
    ExisteAnalisePendente: 0,
    CriacaoEnviadaParaAnalise: 1,
    CriacaoCadastradaComSucesso: 2,
    EdicaoEnviadoParaAnalise: 3,
    EdicaoCadastraoaComSucesso: 4,
    VinculoEnviadoParaAnalise: 5,
    VinculoCadastradoComSucesso: 6
  },
  TextoBooleano: {
    'N/A': false,
    Não: false,
    Sim: true,
    N: false,
    S: true
  },
  TipoBloqueioConta: {
    SemBloqueio: {
      value: 0,
      text: 'Sem Bloqueio'
    },
    Debito: {
      value: 1,
      text: 'Débito'
    },
    Credito: {
      value: 2,
      text: 'Crédito'
    },
    DebitoCredito: {
      value: 3,
      text: 'Débito e Crédito'
    }
  },
  TiposTransacaoLimiteAdicional: {
    Saque: 1,
    Gastos: 2,
    TED: 3,
    Transferência: 4,
    'Pagamento Boleto': 5,
    Pix: 6
  },
  TipoResponseContextoCadastros: {
    Sucesso: 0,
    Alerta: 1,
    Erro: 2
  },
  SituacaoAgendamento: {
    Agendado: 32,
    Executado: 42,
    Cancelado: 34,
    Reprocessar: 50
  },
  TiposSituacao: {
    Ativado: 1,
    Desativado: 2
  },
  TipoDesconto: {
    Isento: 0,
    ValorFixo: 1,
    PercentualDataInformada: 2,
    ValorAntecipacao: 3,
    PercentualAntecipacao: 5
  },
  TipoProcessamentoTED: {
    PAG0108: 1,
    STR0008: 2,
    STR0025: 3,
    STR0007: 7
  },
  StatusRecuperacaoValores: {
    Criada: 1,
    Rastreando: 2,
    Analisando: 3,
    Analisadas: 4,
    Reembolsando: 5,
    Finalizada: 6,
    Cancelada: 7
  },
  FeatureFlag: {
    AntifraudeCmSpi: 1,
    AntifraudeBmpSpi: 2,
    BloqueioEnvioPix: 4,
    AlteracaBoleto: 10,
    CancelamentoBoleto: 12,
    CadastroCedente: 13,
    RegistroArqCNAB400: 14,
    PagadorEletronicoGestao: 15,
    MatrizTransacional: 19,
    BloqueioSaldoManual: 20
  }
}
